import {Grid} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

const ActivationRequestActions = (props) => {
    return (
        <Grid container justifyContent={"flex-end"}>
            <Button variant="contained"
                    onClick={props.onChiudiClick}
                    color="primary">
                Chiudi
            </Button>
        </Grid>
    )
}

ActivationRequestActions.propTypes = {
    onChiudiClick: PropTypes.func.isRequired,
}

export default ActivationRequestActions;